import React from "react";
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { Popup } from "components/Popup"
import "./MoveInfo.scss"
import { iconHour } from "assets/images"
import { getEstFlowEstimateDetails } from "../../core/services/moveDetailsByCustomer"
export interface MoveInfoProps {
    valuationText?: any;
    estimateText?: any;
    title1?: any;
    content1?: any;
    title2?: any;
    content2?: any;
}

export interface MoveInfoState {
    open1?: boolean;
    open2?: boolean;
    Estimator: any;
}

class MoveInfo extends React.Component<MoveInfoProps, MoveInfoState> {
    private _isMounted: boolean = false;
    constructor(props: MoveInfoProps) {
        super(props);
        this.state = {
            open1: false,
            open2: false,
            Estimator: []
        };
    }
    handleOpen1 = () => {
        this.setState({ open1: true });
    };
    handleOpen2 = () => {
        this.setState({ open2: true });
    };
    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        let response = await getEstFlowEstimateDetails(CID)

        console.log(response);
        this.setState({ Estimator: response[0] })
        console.log("EstimatorDetails:" + JSON.stringify(this.state.Estimator));
        localStorage.setItem("EstimatorDetails", JSON.stringify(this.state.Estimator))
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        var moveTime = parseFloat(this.state.Estimator.loadEstimatedHours) + parseFloat(this.state.Estimator.unloadEstimatedHours) + parseFloat(this.state.Estimator.travelHours)

        return (
            <div className="moveinfo-list">
                {
                    this.state.Estimator?.isDisplayFVP > 0 && (
                        <div className="moveinfo-detail">
                            <div className="img-bg"><img src={iconHour} alt="" /></div>
                            <div><p>{this.props.valuationText}</p></div>
                            <div>
                                <SimpleLineIcon name="info" onClick={() => this.handleOpen1()} />
                                <Popup open={this.state.open1}
                                    onClose={() => this.setState({ open1: false })}
                                    title={this.props.title1}
                                    content={this.props.content1}
                                />
                            </div>
                        </div>
                    )
                }

                <div className="moveinfo-detail">
                    <div className="img-bg"><img src={iconHour} alt="" /></div>
                    <div><p>{this.props.estimateText}</p></div>
                    <div>
                        <SimpleLineIcon name="info" onClick={() => this.handleOpen2()} />
                        <Popup open={this.state.open2}
                            onClose={() => this.setState({ open2: false })}
                            title={this.props.title2}
                            content={this.props.content2}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default MoveInfo;